@import "../../../globalStyles/commons";

$border-width: 0.0625rem;

:host .button-group {
  display: flex;

  slot::slotted(goat-button) {
    display: block;
    margin: 0;
    --goat-button-border-width: #{$border-width} 0 #{$border-width} #{$border-width};
    --goat-button-border-radius: 0;
  }

  slot::slotted(goat-button:first-child) {
    --goat-button-border-radius: #{v(--border-radius)} 0 0 #{v(--border-radius)};
  }

  slot::slotted(goat-button:last-child) {
    --goat-button-border-width: #{$border-width};
    --goat-button-border-radius: 0 #{v(--border-radius)} #{v(--border-radius)} 0;
  }

  slot::slotted(goat-button:only-child) {
    --goat-button-border-radius: #{v(--border-radius)};
    --goat-button-border-width: #{$border-width};
  }
}
